export const MapType = {
  DEFAULT: 'default',
  SHARE: 'share'
}
